<div class="w-screen loading-container">

    <div class="mt-6">
      <div class="mx-auto w-min">
        <img *ngIf="detailFetched && spDetail?.image" [src]="spDetail.image" alt="logo" class="border-circle" height="80"
        (load)="imageLoaded = true" [class.hidden]="!imageLoaded">
        <!-- placeholder - {{!detailFetched && !imageLoaded}} -->
        <p-skeleton *ngIf="!detailFetched || !imageLoaded" shape="circle" size="5rem" styleClass="mb-3" />
      </div>
    </div>
    <div class="text-2xl text-dark-blue">
      <!-- ABC Laundry LLC -->
       <div *ngIf="detailFetched && spDetail.name">{{spDetail.name}}</div>
       <div class="mx-auto w-min" *ngIf="!detailFetched || !spDetail?.name">
        <p-skeleton width="14rem" height="2rem" styleClass="my-2" />
       </div>
    </div>
    <div>
      <!-- Laundry -->
      <div *ngIf="detailFetched && spDetail?.name">{{ spDetail.type | titlecase}}</div>
      <div class="mx-auto w-min" *ngIf="!detailFetched || !spDetail?.name">
        <p-skeleton width="8rem" height="1.5rem" styleClass="my-2" />
      </div>
    </div>

    <div class="mt-6 text-gray5 text-center flex justify-content-center">
      <div class="loading-box">
        <span class="loading-text">Loading great stuff...</span>
        <div class="progress-overlay"></div>
      </div>
    </div>

    <div class="mt-7 text-dark-blue text-sm">
      <span class="font-light">Powered by </span> <span class="font-medium">PRIME ACCESS</span>
    </div>
</div>
